import { Drawer } from '@mui/material';
import { ReactNode } from 'react';

export default function CustomDrawer({
  isOpen,
  onClose,
  children,
  isDrawerOpen,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  isDrawerOpen?: boolean;
}) {
  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      className="popover-menu"
      onClose={() => {
        onClose();
      }}
      ModalProps={{ keepMounted: true }}
      slotProps={{
        paper: {
          className: 'popover-menu-paper',
          sx: {
            transform: isDrawerOpen ? 'translateY(0%)' : 'translateY(100%)',
            transition: 'transform 0.3s ease',
          },
        },
      }}
    >
      {children}
    </Drawer>
  );
}
